




















import mixins from '@/utils/mixins';
import Proxyable from '@/mixins/proxyable';

export default mixins(Proxyable).extend({
  data: () => ({
    operators: [
      { operator: 'Add', symbol: '+' },
      { operator: 'Subtract', symbol: '-' },
      { operator: 'Multiply', symbol: '*' },
      { operator: 'Divide', symbol: '/' },
      { operator: 'Ceil', symbol: 'ceil' }
    ]
  }),

  methods: {
    updateOperator() {
      this.$emit('operatorUpdated');
    }
  }
});
